import { useHistory } from 'react-router';
import * as queryString from 'query-string';
import { useEffect, useCallback } from 'react';
import { POSTCODE } from '../../productCatalog/constants/urlParams';

export interface IParamState {
  param: string | null | undefined;
}

export interface IUrlPersistentPostcode {
  setUrlPostcode: (data: string, shouldSetParam?: boolean) => void;
  getUrlPostcode: () => IParamState;
  removeUrlPostcode: () => void;
}

export const useUrlPersistentPostcode: (code?: string) => IUrlPersistentPostcode = code => {
  const history = useHistory();

  // @TODO: Have a single setPostcode for setting the state. Persist to url automatically with useEffect.
  const setUrlPostcode: (data: string) => void = useCallback(
    data => {
      const search = queryString.parse(history.location.search, { arrayFormat: 'comma' });
      if (search[POSTCODE] !== data) {
        search[POSTCODE] = data;
        const parameter: string = queryString.stringify(search, { arrayFormat: 'comma' });

        history.replace({ ...history.location, search: parameter });
      }
    },
    [history],
  );

  const getUrlPostcode: () => IParamState = useCallback(() => {
    const parsedQueryString = queryString.parse(history.location.search)[POSTCODE];
    if (typeof parsedQueryString === 'string') {
      return { param: parsedQueryString ?? '' };
    }

    return { param: null };
  }, [history.location.search]);

  const removeUrlPostcode: () => void = useCallback(() => {
    const search = queryString.parse(history.location.search, { arrayFormat: 'comma' });
    if (search[POSTCODE]) {
      delete search[POSTCODE];
      const parameters: string = queryString.stringify(search, { arrayFormat: 'comma' });

      history.replace({
        ...history.location,
        search: parameters,
      });
    }
  }, [history]);

  useEffect(() => {
    if (code) {
      setUrlPostcode(code);
    }
  }, [history.location.search]);

  return { setUrlPostcode, getUrlPostcode, removeUrlPostcode };
};
